// extracted by mini-css-extract-plugin
export default {"style-section":"RouteStyleToolkit_style-section__2Jd0_","style-section__title":"RouteStyleToolkit_style-section__title__ETMEw"};